var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-section',{attrs:{"title":"Richieste di personalizzazione","icon":"it-inbox","id":"estimate-requests"}},[_c('div',{staticClass:"Gantt text-left"},[_c('estimate-requests-list',{attrs:{"filter":{ no_initiative: true }}}),_c('hr',{staticClass:"border-light mt-5"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }